import sortAlphabetically from './sortAlphabetically';
import sortNumerically from './sortNumerically';

const sortFacilitiesByDistance = facilities => facilities.sort((a, b) => {
  const {
    distanceFromCurrentUserInKilometers: aKilometers,
    distanceFromCurrentUserInMiles: aMiles,
  } = a;

  const {
    distanceFromCurrentUserInKilometers: bKilometers,
    distanceFromCurrentUserInMiles: bMiles,
  } = b;

  if (aKilometers && bKilometers) {
    return sortNumerically(aKilometers, bKilometers);
  }

  if (aMiles && bMiles) {
    return sortNumerically(aMiles, bMiles);
  }

  return sortAlphabetically(a.name, b.name);
});

export default sortFacilitiesByDistance;
